import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconTitleSvg } from "./IconTitleSvg.mjs";
const IconTitle = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconTitleSvg, ...svgProps }) });
export {
  IconTitle
};
